export default (element, data) => {
    const initDropdown = () => {
      if (data.layout.isAboveBreakpoint('lg')) return;
          const dropdown = element.querySelector('[data-dropdown]')
          dropdown.classList.toggle('max-h-0')
          dropdown.classList.toggle('max-h-[500px]')
    }
  
    const init = () => {
          const dropdownToggleBtn = element.querySelector('[data-dropdown-toggle]')
          dropdownToggleBtn.addEventListener('click', initDropdown)
    }
  
    init()
  }